import Vue from 'vue'
import Vuex from 'vuex'
import _ from "lodash";

// Datos
import textos from "@/data/textos"
import areas from "@/data/areas"
import programas from "@/data/programas"
import contenidos from "@/data/contenidos"


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    textos: textos,
    areas_curriculares: areas,
    programas_presidencia: programas,
    contenidos: contenidos,
    sound: true,
  },
  mutations: {
    toggleSound (state) {
      state.sound = !state.sound;
    }
  },
  actions: {

  },
  getters: {
    soundState: state => {
      return state.sound;
    },
    splashScreen: state => {
      return state.textos.splash;
    },
    homeScreen: state => {
      return state.textos.home;
    },
    estudiantesScreen: state => {
      return state.textos.estudiantes;
    },
    docentesScreen: state => {
      return state.textos.docentes;
    },
    presidenciaScreen: state => {
      return state.textos.presidencia;
    },
    tooltips: state => {
      return state.textos.tooltips;
    },
    about: state => {
      return state.textos.about;
    },
    areas_curriculares: state => {
      return state.areas_curriculares;
    },
    programas_presidencia: state => {
      return state.programas_presidencia;
    },
    contenidos: state => {
      return state.contenidos;
    },
    contenidosEstudiante: state => {
      return _.filter(state.contenidos, { 'poblacion': "Estudiante" });
    },
    contenidosDocente: state => {
      return _.filter(state.contenidos, { 'poblacion': "Docente" });
    },
    contenidosPresidencia: state => {
      return _.filter(state.contenidos, { 'poblacion': "Presidencia" });
    },
    tiposRecursosDocente: (state, getters) => {
      return _.map(_.uniqBy(getters.contenidosDocente, "tipo_recurso"), "tipo_recurso");
    },
    // tiposPresidencia: (state, getters) => {
    //   return _.map(_.uniqBy(getters.contenidosPresidencia, "tipo_recurso"), "tipo_recurso");
    // }
  }
})
